<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">获取终端信息</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			terminal_info接口提供了获取终端设备信息的功能。
		</p>
		<h3 class="doc_main_h3">调用URL</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"><a href="https://skfrm.cn/APIV2/terminal_info">https://skfrm.cn/APIV2/terminal_info</a></code></pre>		
        <h3 class="doc_main_h3">请求参数</h3>
		<frm-Request-parameters :propsTableData="frmRequestParams"></frm-Request-parameters>
        <h3 class="doc_main_h3">返回值说明</h3>
		<frm-Return-Value-New :propsTableData='frmReturnValueNew'></frm-Return-Value-New>
		<!-- <h3 class="doc_main_h3">通用错误码</h3>
		<frm-Error-Code :propsTableData='frmErrorCode'></frm-Error-Code> -->
		<h3 class="doc_main_h3">返回值示例</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">成功：
	{
		"error_code":"0",
		"error_msg":"success",
		"data":
		{
			"terminal_id":"408",
			"terminal_name":"新终端",
			"platform":"Android4.4.2",
			"sdk_version":"V2.1.1",
			"ip":"223.20.180.213",
			"ability":"2",
			"last_time":"2018-09-23 22:14:02",
			"udid":"6c666468-959a-6e96-9f95-c6659a9d9b669465c56b",
			"visual_image":"/Uploads/visual/2018-09-23/1537712044667.jpg",
			"image_url":"/Uploads/visual/2018-09-23/1537712044667.jpg"
		}
	}
失败：
	{
		"error_code":"4",
		"error_msg":"服务器内部错误"
	}
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import FrmRequestParamsTable from'../../../../components/frmRequestParamsTable';
import FrmReturnValueTableNew from '../../../../components/frmReturnValueTableNew';
import FrmErrorCodeTable from '../../../../components/frmErrorCodeTable';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'frm-Request-parameters':FrmRequestParamsTable,
'frm-Return-Value-New':FrmReturnValueTableNew,
'frm-Error-Code':FrmErrorCodeTable, 
		},
		data(){
			return{
				isPathData:['FRM API-v2','终端管理','获取终端信息'],
				frmRequestParams:[
					{"require":"是","name":"account_id","type":"int","msg":"当前账号id"},
					{"require":"是","name":"token","type":"string","msg":"当前账号登录后返回的token"},
					{"require":"是","name":"project_id","type":"int","msg":"项目id"},
					{"require":"是","name":"terminal_id","type":"int","msg":"终端id"},
				],
				frmReturnvalue:[
					{"Parameter":"error_code","name":"string","msg":"0 成功  1 失败"},
					{"Parameter":"error_msg","name":"string","msg":"成功返回 success  失败返回 fail"},
					{"Parameter":"data","name":"array","msg":"                                  "},
				],
				frmReturnValueNew:[
					{
						"Parameter":"error_code",
						"name":"string",
						"msg":"0 成功  1 失败",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"error_msg",
						"name":"string",
						"msg":"成功返回 success  失败返回 fail",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"终端详细信息数组",
						"rowspan":11,
						"colspan":1,
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"terminal_id   string    终端id",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"terminal_name   string    终端名称",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"ability   string    1 正常 2禁用",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"ip   string    终端最后接入平台ip",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"platform   string   终端平台",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"visual_image   string    终端开机图片URL",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"sdk_version   string    SDK版本",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"last_time   string    终端最后访问时间",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"active   string    1在线 2不在线",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"image_url   string    主题图url",
					},
				],
				frmErrorCode:[
					{"Statuscode":"1","errormessage":"fail","msg":"服务器繁忙"},
					{"Statuscode":"9001","errormessage":"token无效","msg":"token过期"},
				],

			}
		},
		watch:{

		},
		methods:{
			Trim(str){ 
					return str.replace(/(^\s*)|(\s*$)/g, ""); 
			}
		},
		created(){
			if (this.frmReturnValueNew) {
				for(var i=0;i<this.frmReturnValueNew.length;i++){
					console.log(this.frmReturnValueNew[i].msg)
					this.frmReturnValueNew[i].msg =this.Trim(this.frmReturnValueNew[i].msg)
				}
			}
		},
		mounted(){
			if (this.frmReturnValueNew) {
				for(var i=0;i<this.frmReturnValueNew.length;i++){
					console.log(this.frmReturnValueNew[i].msg)
					this.frmReturnValueNew[i].msg =this.Trim(this.frmReturnValueNew[i].msg)
				}
			}
		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/Terminalmanagement/GettingTerminalInformation.vue